function getElementHeight(className) {
  const element = document.querySelector(`.${className}`);
  if (!element) return 0;

  // Prefer exact rendering box size, avoid including margin.
  const rect = element.getBoundingClientRect();
  if (rect && rect.height > 0) {
    return rect.height;
  }

  // Fallback to offsetHeight if the element is potentially not in domflow yet.
  if (element.offsetHeight > 0) {
    return element.offsetHeight;
  }

  // Try computed style if anything is hidden/transitioning.
  const computed = window.getComputedStyle(element);
  if (computed && computed.height && computed.height !== 'auto') {
    const parsed = parseFloat(computed.height);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
}

function updateHeightToCSSVar(className, cssVarName) {
  const height = getElementHeight(className);
  document.documentElement.style.setProperty(cssVarName, `${height}px`);
}

// Usage
const updatePlpMenuTop = () => updateHeightToCSSVar('plp-menu-sticky', '--plp-menu-top');

window.addEventListener('load', updatePlpMenuTop);
window.addEventListener('resize', updatePlpMenuTop);

// Ensure updates when DOM mutations can change header/menu size.
const observer = new MutationObserver(updatePlpMenuTop);
observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true });

class StickyPlpMenu extends HTMLElement {
  connectedCallback() {
    // Hoist sticky positioning to the .shopify-section wrapper so the element
    // sticks within the full-page scroll context, not just its own wrapper height.
    this.sectionWrapper = this.closest('.shopify-section');
    if (this.sectionWrapper) this.sectionWrapper.classList.add('plp-menu-sticky');

    this.nav = this.querySelector('.plp-menu');
    this.activeItem = this.querySelector('.plp-menu__link--active');
    this.swiper = null;

    this.initSwiper();
    if (this.activeItem) {
      this.scrollActiveIntoView();
    }

    // Initialise the shared offset manager now that plp-menu-sticky class is set
    window.StickyOffsetManager.init();
  }

  disconnectedCallback() {
    if (this.swiper) this.swiper.destroy(true, true);
  }

  scrollActiveIntoView() {
    const item = this.activeItem.parentElement; // the <li>
    const index = Array.from(item.parentElement.children).indexOf(item);

    if (this.swiper && index > -1) {
      this.swiper.slideTo(index, 0);
      return;
    }

    this.nav.scrollLeft = item.offsetLeft;
  }

  initSwiper() {
    if (!this.nav) return;

    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', () => this.initSwiper(), { once: true });
      return;
    }

    this.swiper = new Swiper(this.nav, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 0,
      // slidesOffsetBefore: 16,
      // slidesOffsetAfter: 16,
      freeMode: true,
      watchOverflow: true,
      simulateTouch: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
    });
  }
}

customElements.define('sticky-plp-menu', StickyPlpMenu);
